export default __webpack_public_path__ + "static/media/lib-2.5ef22a00.jpg";